<template>
  <section v-if="itemIsInCart(item.id)" class="incart">
    <inline-svg
      @click.stop="checkout"
      class="ico-cart"
      src="/images/cart.svg"
    ></inline-svg>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import InteractionMixin from '@/mixins/InteractionMixin'

export default {
  name: 'IsInCart',
  props: ['item'],
  mixins: [InteractionMixin],
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  methods: {
    itemIsInCart(id) {
      return this.printStoreStore.orderDetails.cart.find(
        (item) => item.id === id
      )
    },
    checkout() {
      const printOrder = this.rootStore.interactions.find(
        (ia) => ia.destination === 'printOrder'
      )
      this.startInteraction(printOrder)
    }
  }
}
</script>

<style lang="scss" scoped>
.incart {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.5) 0 0 12px -6px;
  background-color: white;
  text-align: center;
  padding-top: 4px;
}
svg {
  width: 15px;
}

.ico-cart {
  path {
    stroke: var(--sub-color);
  }

  circle {
    fill: var(--sub-color);
  }
}
</style>
